module.exports = __webpack_public_path__ + "media/images/icon_interact_area-8bbbb044409c7a201a3b5dcf8998f806.png";